import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import logo from '../../images/logo.png';
import './NotFound.css';
import PageHeader from '../Page Header/PageHeader';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <PageHeader />
      <div className="not-found__container">
        <div className="not-found__content">
          
          <img
          src={logo}
          alt="Artemis Logo"
          className="not-found__logo"
          />
          <h1 className="not-found__title">404</h1>
          <p className="not-found__message">
            The page you're looking for doesn't seem to exist.
          </p>
        </div>

        <button
          onClick={() => navigate('/')}
          className="not-found__button"
        >
          <Home className="not-found__button-icon" />
          <span>Return Home</span>
        </button>
      </div>
    </div>
  );
};

export default NotFound;
